import { render } from "./EducationList.vue?vue&type=template&id=77c97a26&scoped=true"
import script from "./EducationList.vue?vue&type=script&lang=js"
export * from "./EducationList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-77c97a26"

export default script